export default __webpack_public_path__ + "static/production-2-03c7a549b2af3f8901d165a6dc4a8dd5.webp";